var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNikeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 100",
    style: {
      enableBackground: "new 0 0 150 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6,23.4c-0.2,0.3-0.4,0.7-0.6,1c-2,3.6-3.6,7.4-4.5,11.5c-0.6,2.9-0.8,5.7,0,8.6c1.3,4.8,4.4,7.9,9.2,9.2 c2.3,0.6,4.7,0.7,7.2,0.6c4-0.2,7.9-1.2,11.8-2.2c18-4.8,36-9.6,54-14.4c16.9-4.5,33.9-9,50.8-13.5c0.2,0,0.3-0.1,0.5-0.1 c-0.2,0.1-0.4,0.2-0.6,0.3c-35,15-69.9,29.9-104.9,44.9c-4,1.7-8,3.4-12.2,4.7c-3.9,1.2-7.8,2.2-11.9,2.5c-3.3,0.3-6.6,0.2-9.8-0.9 C5,73.7,1.4,69.9,0.3,63.9c-0.5-3-0.2-5.9,0.5-8.8c1.1-4.6,3.1-8.8,5.5-12.8c2.3-3.8,5.1-7.4,8-10.8c2.4-2.8,4.8-5.5,7.2-8.2 C21.5,23.3,21.5,23.4,21.6,23.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikeLogo);
export default __webpack_public_path__ + "static/media/nike-logo.30f290172c9f18f1c720f1d4b180a7a9.svg";
export { ForwardRef as ReactComponent };